import { useState } from 'react';

export const useSelectedRows = () => {
  const [selectedRowIds, setSelectedRowIds] = useState({});

  return { selectedRowIds, setSelectedRowIds };
};
